import React from 'react';
import { Link } from 'react-router-dom';
import Styles from './style.module.css';
import { Container } from 'react-bootstrap';

export default function ErrorPage() {
    return (
        <div className={Styles.errorPageWrapper}>
            <Container className="text-center">
                <div className={Styles.svgContainer}>
                    <svg viewBox="-100 -50 1000 550" width="100%" height="100%" className={Styles.svgAnimation}>
                        <defs>
                            {/* Yellow Gradient for '4' */}
                            <linearGradient id="gradYellow" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="50%" stopColor="#fde047" />
                                <stop offset="50%" stopColor="#facc15" />
                            </linearGradient>

                            {/* Blue Gradient for '0' */}
                            <linearGradient id="gradBlue" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="50%" stopColor="#38bdf8" />
                                <stop offset="50%" stopColor="#0284c7" />
                            </linearGradient>
                        </defs>

                        {/* Background Text (3D Colored 404) */}
                        <g className={Styles.text404}>
                            {/* Shadows / 3D Extrusion */}
                            <text x="210" y="200" fontSize="280" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fill="#ca8a04" textAnchor="middle" transform="translate(15, 15)">4</text>
                            <text x="400" y="200" fontSize="280" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fill="#0369a1" textAnchor="middle" transform="translate(15, 15)">0</text>
                            <text x="590" y="200" fontSize="280" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fill="#ca8a04" textAnchor="middle" transform="translate(15, 15)">4</text>

                            {/* Front Faces */}
                            <text x="210" y="200" fontSize="280" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fill="url(#gradYellow)" textAnchor="middle">4</text>
                            <text x="400" y="200" fontSize="280" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fill="url(#gradBlue)" textAnchor="middle">0</text>
                            <text x="590" y="200" fontSize="280" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fill="url(#gradYellow)" textAnchor="middle">4</text>
                        </g>

                        {/* Ground and Hole */}
                        <path d="M -200 300 L 350 300 A 50 20 0 0 0 450 300 L 1000 300" stroke="#94a3b8" strokeWidth="6" fill="none" />
                        <ellipse cx="400" cy="300" rx="48" ry="18" fill="#f8fafc" className={Styles.holeInner} />

                        {/* Student */}
                        <g className={Styles.student}>
                            <g className={Styles.studentShakeWrapper}>
                                <circle cx="50" cy="240" r="15" fill="#3b82f6" />
                                <line x1="50" y1="255" x2="50" y2="285" stroke="#3b82f6" strokeWidth="6" strokeLinecap="round" />

                                <line x1="50" y1="265" x2="35" y2="280" stroke="#3b82f6" strokeWidth="6" strokeLinecap="round" className={Styles.runArm1} />
                                <line x1="50" y1="265" x2="65" y2="280" stroke="#3b82f6" strokeWidth="6" strokeLinecap="round" className={Styles.runArm2} />

                                <line x1="50" y1="285" x2="40" y2="300" stroke="#3b82f6" strokeWidth="6" strokeLinecap="round" className={Styles.runLeg1} />
                                <line x1="50" y1="285" x2="60" y2="300" stroke="#3b82f6" strokeWidth="6" strokeLinecap="round" className={Styles.runLeg2} />
                            </g>
                        </g>

                        {/* Teacher */}
                        <g className={Styles.teacher}>
                            <circle cx="50" cy="235" r="16" fill="#ef4444" />
                            {/* Angry Eyes / Glasses */}
                            <line x1="55" y1="231" x2="65" y2="235" stroke="#111827" strokeWidth="2" strokeLinecap="round" />
                            <line x1="50" y1="251" x2="50" y2="285" stroke="#ef4444" strokeWidth="7" strokeLinecap="round" />

                            <line x1="50" y1="260" x2="35" y2="275" stroke="#ef4444" strokeWidth="6" strokeLinecap="round" className={Styles.runArm2} />

                            {/* Arm with stick */}
                            <g className={Styles.teacherArmWithStick}>
                                <line x1="50" y1="260" x2="65" y2="275" stroke="#ef4444" strokeWidth="6" strokeLinecap="round" />
                                <line x1="60" y1="270" x2="80" y2="220" stroke="#78350f" strokeWidth="4" strokeLinecap="round" />
                            </g>

                            <line x1="50" y1="285" x2="40" y2="300" stroke="#ef4444" strokeWidth="6" strokeLinecap="round" className={Styles.runLeg1} />
                            <line x1="50" y1="285" x2="60" y2="300" stroke="#ef4444" strokeWidth="6" strokeLinecap="round" className={Styles.runLeg2} />
                        </g>
                    </svg>
                    <div className={Styles.textContent}>
                        <h2 className={Styles.errorTitle}>يادمج! إيه اللي جابك هنا</h2>
                        <p className={Styles.errorSubtitle}>
                            الصفحة التي تبحث عنها غير موجودة. ربما تم نقلها، أو أنك ضللت الطريق.
                        </p>
                        <Link to="/" className={Styles.homeBtn}>من هنا يا هندسة</Link>
                    </div>
                </div>
            </Container>
        </div>
    );
}
